import React, {useState, useEffect} from 'react';
import {contact} from 'config/translate/variables'
import PubSub from "services/PubSub/";
import TagManagerService from 'services/TagManager';
import PropTypes from 'prop-types';
import LoginService from 'services/Login';
import Link from 'components/Link';
import style from './style.scss'; //NOSONAR

let actions = [];

const Header = (props) => {
    const titleActive = (props.title === 'no');
    const [title, setTitle] = useState(null);
    const [quantity, setQuantity] = useState(0);
    const pathName = window.location.href;
    const path = window ? window.location.pathname : null;

    useEffect(()=>{
        actions.push(PubSub.register('cart_update_title', changeTitle));
        LoginService.validatePrivateUrl();

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    useEffect(()=>{
        let currentPage = path ? path.split('/') : null;
        if(currentPage && currentPage[1] == 'checkout' && (currentPage.length < 4 || currentPage[3] == '')){
            setTitle('Checkout');
        } 
        if(currentPage && currentPage[2] == 'cart' && (currentPage.length < 4 || currentPage[3] == '')){
            setTitle('Mi Carro');
        }
    },[path]);

    const changeTitle = (event) => {
        if(!(event && event.value)) return false;
        const itemQuantity = event.value.quantity;
        const newTitle = event.value.title;

        if(newTitle){
            setTitle(newTitle);
        }

        if(quantity){
            setQuantity(itemQuantity);
        }
    };

    const clickHeader = (action, tag, category) => {
        TagManagerService.interaction(action, tag, category);
    }

    return (
        <header className="cart-header">
            <div className="cart-header-container">
                <Link to='/' onClick={() => clickHeader('Logo Jumbo', pathName , 'Header Ckeckout')} className="cart-header-logo-link jumbo-icon-logo" aria-label="Jumbo Chile" />
                <span className='car-header-title-wrap'>
                    <h1 className="car-header-title">{!titleActive && title}</h1>
                    {title === 'Mi carro' && quantity > 0 && <span className="car-header-quantity-products">{quantity} {quantity > 1 ? 'productos' : 'producto'}</span>}
                </span>
                <a href={`tel:${contact.phone}`} className="car-header-span-phone-container" onClick={() => clickHeader('Número de Contacto', pathName , 'Header Ckeckout')}>
                    <i className="font-icn phone-header" />
                    <span className="car-header-span-phone">{contact.phone}</span>
                </a>
            </div>
        </header>
    )
}

Header.propTypes = {
    title: PropTypes.string
};

export default Header;
